export default [
    { title: 'Ozono', id: 'item1', src: 'ozono.png', src_hover: 'ozono_h.png', route: '/AirQualityInformationPdf' },
    { title: 'Material Particulado', id: 'item2', src: 'm_particulado.png', src_hover: 'm_particulado_h.png', route: '/AirQualityInformationPdf'},
    { title: 'Dioxido de Azufre', id: 'item3', src: 'd_azufre.png', src_hover: 'd_azufre_h.png', route: '/AirQualityInformationPdf'}
  ]